import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "introduction-to-shop"
    }}>{`Introduction to Shop`}</h1>
    <p>{`In Chawkbazar application shop is one the most important features need to understand. Based on the user role shop feature can be divided into 3 parts. Lets discuss is here.`}</p>
    <h2 {...{
      "id": "super-admin"
    }}>{`Super Admin`}</h2>
    <p>{`As, super admin has the supreme authority over any vendor, so he/she can control any listed shops in the application. Here are the key notes for super admin,`}</p>
    <ul>
      <li parentName="ul">{`Super admin can see all the published & inactive shops.`}</li>
      <li parentName="ul">{`During shop approval super admin can set the commission rate for that shop.`}</li>
      <li parentName="ul">{`Super admin can control actions for approval & disapproval of any shop.`}</li>
      <li parentName="ul">{`Super admin has access to visit every shop's own dashboard & inner pages.`}</li>
      <li parentName="ul">{`Super admin is also a vendor himself/herself. So, he/she can listed his own shop & control them as a vendor perspective.  `}</li>
    </ul>
    <h2 {...{
      "id": "vendor"
    }}>{`Vendor`}</h2>
    <p>{`Vendors are generally the shop owner. A vendor can register in the application as a seller. And he/she can open a shop based on agreement with super admin.
Some key notes for Vendors,`}</p>
    <ul>
      <li parentName="ul">{`Vendor can listed his/her own products.`}</li>
      <li parentName="ul">{`Vendor can assign staffs for his/her shop.`}</li>
      <li parentName="ul">{`Vendor can monitor his orders, based on his provided order status, super admin will take rest actions.`}</li>
      <li parentName="ul">{`Vendor can set his/her own FAQs based on his shop individually. For example, a Grocery shop's FAQ may not be similar with a Gadget shop's FAQ. `}</li>
      <li parentName="ul">{`Vendor can set shop specific Terms & Conditions, if and only if Super admin gave permission.`}</li>
    </ul>
    <h2 {...{
      "id": "staff"
    }}>{`Staff`}</h2>
    <p>{`Staffs are assigned by vendor. A shop staff's main duty is to act as a helping hand to vendor, but his/her has some limitations in permission. Some key notes for Staff role, `}</p>
    <ul>
      <li parentName="ul">{`One shop staff has no access to another shop of a same vendor.`}</li>
      <li parentName="ul">{`Staffs can add FAQs to his/her assigned shop.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      